module.exports = __webpack_public_path__ + "img/REG_ALIM_SANS_GLUTEN_LISTE_NOM.b88cbc98.svg";